import { EventBus } from './eventBus';

export function toast(message, variant, position = 'b-toaster-bottom-right', autoHideDelay = 15000) {
    EventBus.$emit('show-toast', {
        message: message,
        title: getTitle(variant), 
        autoHideDelay: autoHideDelay,
        appendToast: true,
        solid: true,
        variant: variant,
        toaster: position
    });
}

const getTitle = (variant) => {
    switch (variant) {
        case variants.SUCCESS: return 'Uspeh!'
        case variants.WARNING: return 'Upozorenje!'
        case variants.ERROR: return 'Greška!'
        default: ''
    }
}

export const variants = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'danger',
}
